// KA-1511 controlled rollout. The admin panel has no runtime feature-flag
// service, so gating is a build-time Vite env var (baked per environment from
// the .env templates): on in dev for review, off in prod until sign-off.
// Flipping requires a rebuild/redeploy of the admin panel.
export const isOrgHealthCheckEnabled = (): boolean => import.meta.env.VITE_ORG_HEALTH_CHECK_ENABLED === 'true';
